"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynamicTextureFactory = dynamicTextureFactory;
var _pixi = require("pixi.js");
function dynamicTextureFactory(sprite, filter, identifier, renderer) {
  var renderTexture = _pixi.RenderTexture.create({
    width: sprite.width,
    height: sprite.height,
    resolution: 1
  });
  if (filter) sprite.filters = [filter];
  renderer.render(sprite, {
    renderTexture: renderTexture
  });
  _pixi.Texture.addToCache(renderTexture, identifier);
  renderer.plugins.prepare.upload(_pixi.Texture.from(identifier));
  sprite.destroy();
  return renderTexture;
}
//# sourceMappingURL=dynamicTextureFactory.js.map